// extracted by mini-css-extract-plugin
export var controls = "PostHeaderVideo-module--controls--dab9d";
export var media = "PostHeaderVideo-module--media--1bfd1";
export var mediaActive = "PostHeaderVideo-module--media-active--d0819";
export var mediaControls = "PostHeaderVideo-module--media-controls--130d9";
export var mediaInner = "PostHeaderVideo-module--media-inner--df3df";
export var poster = "PostHeaderVideo-module--poster--20553";
export var video = "PostHeaderVideo-module--video--7c588";